<script setup lang="ts">
    import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    const props = defineProps<{
        employee: Employee;
        data: ChangedFields;
    }>();

    const employeeWithAddress = computed(() => {
        return {
            ...props.employee,
            address: props.employee.addresses[0],
        };
    });

    const values = computed(() => {
        return [
            { name: 'address', group: 'address', key: 'address' },
            { name: 'address2', group: 'address', key: 'address' },
            { name: 'postal_code', group: 'address', key: 'address' },
            { name: 'city', group: 'address', key: 'address' },
            { name: 'country_code', group: 'address', key: 'address' },
        ];
    });
</script>

<template>
    <EmployeeChangesGroup
        :data="data"
        :values="values"
        :employee="employeeWithAddress"
    />
</template>
